import React from 'react';
import LongText from '../Elements/LongText';
import WrapText from '../Elements/WrapText';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import urlHelper from '../Helpers/urlHelper';

export default class SurveyTransferQuestionMappingItem {
  constructor(item) {
    if (item === undefined) {
      this.SurveyTransferQuestionMappingId = '';
      this.SurveyTransferMappingId = '';
      this.TargetTpQuestionId = '';
      this.SourceTpQuestionId = '';
      this.TargetThirdPartyQuestionId = '';
      this.SourceThirdPartyQuestionId = '';
      this.ParentMappingIsActive = '';
      this.SourceType = 'Question';
      this.SourceKey = '';
      this.AnswerOptionMappingCount = 0;
      this.AnswerOptionMappingsSummary = '';
      this.TargetTpQuestionDisplayOrder = '';
      this.TargetTpQuestionText = '';
      this.SourceTpQuestionText = '';
    } else {
      this.initialize(item);
    }
  }

  initialize(item) {
    this.SurveyTransferQuestionMappingId = item.surveyTransferQuestionMappingId;
    this.SurveyTransferMappingId = item.surveyTransferMappingId;
    this.TargetTpQuestionId = item.targetTpQuestionId;
    this.SourceTpQuestionId = item.sourceTpQuestionId;
    this.TargetThirdPartyQuestionId = item.targetThirdPartyQuestionId;
    this.SourceThirdPartyQuestionId = item.sourceThirdPartyQuestionId;
    this.ParentMappingIsActive = item.parentMappingIsActive;
    this.SourceType = item.sourceType ?? 'Question';
    this.SourceKey = item.sourceKey ?? '';
    this.AnswerOptionMappingCount = item.answerOptionMappingCount;
    this.AnswerOptionMappingsSummary = item.answerOptionMappingsSummary;
    this.TargetTpQuestionDisplayOrder = item.targetTpQuestionDisplayOrder;
    this.TargetTpQuestionText = item.targetTpQuestionText;
    this.SourceTpQuestionText = item.sourceTpQuestionText;
  }

  static NameOfTheIdField() {
    return 'SurveyTransferQuestionMappingId';
  }

  static nameOfTheItemDetailList() {
    return 'Question Rule';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = [];

  static DateOnlyFields = [];

  static BoolFields = [];

  static FieldsToShowInListTable = [
    {
      tabName: 'Info',
      tabLabel: 'Info',
      icon: 'fa-solid fa-info',
      data: [
        {
          name: 'SurveyTransferQuestionMappingId',
          label: 'Question Mapping Id',
          width: TabListTableCellWidthEnum.Full,
        },
        { name: 'TargetTpQuestionId', label: 'Target Question Id' },
        { name: 'TargetTpQuestionDisplayOrder', label: 'Target Display Order' },
        { name: 'TargetTpQuestionText', label: 'Target Question', width: TabListTableCellWidthEnum.Full },
        { name: 'SourceTpQuestionId', label: 'Source Question Id' },
        { name: 'SourceTpQuestionText', label: 'Source Question', width: TabListTableCellWidthEnum.Full },
        { name: 'AnswerOptionMappingsSummary', label: 'Answer Option Mappings', width: TabListTableCellWidthEnum.Full },
      ],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Target Order',
        orderById: 'TargetTpQuestionDisplayOrder',
        data: 'TargetTpQuestionDisplayOrder',
        className: 'text-center',
        minWidth: 20,
      },
      {
        label: 'Target Question',
        orderById: 'TargetTpQuestionText',
        data: (item) => <WrapText text={item.TargetTpQuestionText} />,
      },
      {
        label: 'Target 3rd Party Id',
        orderById: 'TargetThirdPartyQuestionId',
        data: 'TargetThirdPartyQuestionId',
        className: 'text-center',
        minWidth: 20,
      },
      {
        label: 'Source Type',
        // Non-sortable: the backend ordering switch doesn't map SourceType.
        orderById: '',
        data: 'SourceType',
        className: 'text-center',
        minWidth: 20,
      },
      {
        label: 'Source Question',
        orderById: 'SourceTpQuestionText',
        // A source-less (ignored) question has no source text; show a muted, italic placeholder.
        data: (item) =>
          !item.SourceTpQuestionText && item.SourceType == 'Question' ? (
            <span style={{ color: 'var(--color-gray, #7d7d7d)', fontStyle: 'italic' }}>Ignored</span>
          ) : (
            <WrapText text={item.SourceTpQuestionText} />
          ),
      },
      {
        // Identifies the source regardless of kind: the source question's 3rd-party id for a
        // 'Question' source, or the job-field key for a 'JobData' source.
        label: 'Source Reference',
        orderById: 'SourceThirdPartyQuestionId',
        data: (item) =>
          item.SourceType === 'JobData'
            ? item.SourceKey ?? (
                <span style={{ color: 'var(--color-gray, #7d7d7d)', fontStyle: 'italic' }}>Ignored</span>
              )
            : item.SourceThirdPartyQuestionId ?? (
                <span style={{ color: 'var(--color-gray, #7d7d7d)', fontStyle: 'italic' }}>Ignored</span>
              ),
        className: 'text-center',
        minWidth: 20,
      },
      {
        // Compact "source → target" summary of this question's answer-option rules. Newline-separated;
        // LongText shows the first pair and reveals the rest via the eye icon, so the column stays small.
        label: 'Answer Options',
        orderById: '',
        data: (item) =>
          SurveyTransferQuestionMappingItem.IsIgnored(item) ? (
            <span style={{ color: 'var(--color-gray, #7d7d7d)', fontStyle: 'italic' }}>Ignored</span>
          ) : (
            <LongText
              text={item.AnswerOptionMappingsSummary}
              maxLength={0}
              // separator={'\n'}
            />
          ),
        minWidth: 30,
      },
      {
        label: 'Id',
        orderById: 'SurveyTransferQuestionMappingId',
        minWidth: 20,
        data: (item) => (
          <LongText
            text={item.SurveyTransferQuestionMappingId}
            maxLength={0}
          />
        ),
      },
      {
        label: 'Actions',
        orderById: '',
        type: FieldTypesEnum.ActionButton,
        data: SurveyTransferQuestionMappingItem.getActionsContent,
        minWidth: 50,
      },
    ];
  }

  // A source-less ("Ignored") question rule: SourceType 'Question' with no source question. Its target
  // options have nothing to map from, so its answer-option rules aren't editable/viewable and the
  // answer-option summary is suppressed. (JobData rules carry a source key and are treated normally.)
  static IsIgnored(item) {
    return item.SourceType === 'Question' && !item.SourceTpQuestionId;
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-edit',
            text: 'Edit',
            // Editing is only allowed while the parent mapping is inactive (enforced in the micro too).
            disabled: item.ParentMappingIsActive === true,
            tooltipText:
              item.ParentMappingIsActive === true
                ? 'Deactivate the survey transfer mapping to edit its rules'
                : 'Edit this question rule',
            onClick: () => SurveyTransferQuestionMappingItem.editFunction(item.SurveyTransferQuestionMappingId, item),
          },
          {
            iconName: 'fa-solid fa-arrow-up-right-from-square',
            text: 'View answer mapping',
            tooltipText: 'View answer option rules',
            // Viewing is always allowed: the answer-option page is read-only while the parent mapping
            // is active and editable otherwise, so it's safe to open in any state.
            disabled: false,
            // Open in a new tab via window.open rather than the menu's `url` prop:
            // DataTableActionButton gates `url` through urlHelper.isUrlOnWhiteList and falls back
            // to '/' (Home) for non-whitelisted hosts (e.g. localhost). getProperUrl builds the
            // same {origin}/...?id= link the working "Question Rules" link uses.
            onClick: () =>
              window.open(
                urlHelper.getProperUrl(
                  'surveytransferansweroptionrulesdetails',
                  `id=${item.SurveyTransferQuestionMappingId}`
                ),
                '_blank'
              ),
          },
        ]}
      />
    );
  }

  // Wired by the hosting page (SurveyTransferQuestionRulesDetails) to open the edit panel.
  static editFunction = (id, item) => {
    alert('Edit function is not wired up.');
  };
}
